// extracted by mini-css-extract-plugin
export default {"shop_container":"Home_shop_container__RszAO","header":"Home_header__SeLUp","contact":"Home_contact__GSWL5"};